export class RenewalInterestRequest {

	country: string;
	operation: string;
	vin: string;
	productId: number;
	coverageId: number;
	productPolicyId: number;

	constructor() {

	}
}
